export default "__VITE_ASSET__C7Dm1S9M__"